import React from "react";

function InterventionDetails({ intervention, onEdit,edit=false ,editRdv=null }) {
// console.log("intervention:",intervention)
  const renderLieuBloc = () => {
    switch (intervention?.lieu_intervention) {
      case "onsite":
      return editRdv ? (
        <div>
          <h5>À domicile</h5>
          <p className="body text-gray-500">{intervention?.adresse_domicile}</p>
        </div>
      ) : (
        <div>
          <h5>À domicile</h5>
          <p className="body text-gray-500">{intervention?.rue}</p>
          <p className="body text-gray-500">{intervention?.ville}</p>
        </div>
      );
      case "chezpro":
        return (
          <div>
            <h5>Chez le professionnel</h5>
            <p className="body text-gray-500">{intervention?.code_postal} {intervention?.ville} {intervention?.etablissement?.adresse_postale}</p>
          </div>
        );
      case "enligne":
        return (
          <div>
            <h5>En Ligne</h5>
            <p className="body text-gray-500">{intervention?.meeting_link}</p>
          </div>
        );
        default :
        return(
          <>Unkown
          </>
        )
    }
  };
  return (
    <div className="bg-gray-100 shadow-md rounded-lg mt-24">
      <div className="intervention flex-between">
      {renderLieuBloc()}
        {edit && (
        <div>
          <button onClick={onEdit}  className="link-blue">
            {" "}
            Modifier{" "} <img src="/images/edit.svg" alt="icon edit" className="ml-8" />
          </button>{" "}
         
        </div>
         )}
      </div>
      {intervention?.equipe &&
      <div className="intervention flex-between">
        <div>
          <h5>Employé demandé</h5>
          <p className="body text-gray-500">{intervention?.equipe?.name}</p>
        </div>
        {intervention?.edit && (
          <div>
            <a href="#" className="link-blue">
              {" "}
              Modifier{" "}
            </a>{" "}
            <img src="/images/edit.svg" />
          </div>
        )}
      </div>
        }
    </div>
  );
}

export default InterventionDetails;
